export default {"src":"/_next/static/media/woman-thumbs-up-2.colour.4af30dd4.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};